import { render, staticRenderFns } from "./Things.vue?vue&type=template&id=3bfa804c&scoped=true&"
import script from "./Things.vue?vue&type=script&lang=ts&"
export * from "./Things.vue?vue&type=script&lang=ts&"
import style0 from "./Things.vue?vue&type=style&index=0&id=3bfa804c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfa804c",
  null
  
)

export default component.exports